import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { foreignRoleRedirect } from './role-areas';

/**
 * Guards /help: available to any authenticated socio, regardless of
 * registration status (a socio may need help precisely during onboarding).
 * - Anonymous users → /
 * - Managers → /manager
 * - Ventas → /sales
 * - Socios with no status yet → /home
 * - Any socio with a status → allow
 */
export const helpGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/home']);
          const away = foreignRoleRedirect(router, status.role, ['socio']);
          if (away) return away;
          return true;
        }),
      );
    }),
  );
};
